"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoAddMomentToTraceiD = void 0;

var _ = require("../../");

var _downArrow = _interopRequireDefault(require("../../assets/img/down-arrow.svg"));

var _helpers = require("../../util/helpers");

var _react = _interopRequireDefault(require("react"));

require("./AutoAddMomentToTraceiD.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// AutoAddMomentToTraceiD Component
var AutoAddMomentToTraceiD = function AutoAddMomentToTraceiD(_ref) {
  var user = _ref.user,
      title = _ref.title,
      moment = _ref.moment,
      loading = _ref.loading,
      thumbnail = _ref.thumbnail,
      playlistLink = _ref.playlistLink,
      playlistTitle = _ref.playlistTitle,
      didCreateNewItem = _ref.didCreateNewItem,
      onClose = _ref.onClose;
  var firstName = user ? user.first_name : null;
  var lastName = user ? user.last_name : null;
  var userId = user ? user.user_id : null;
  return /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "AutoAddMomentToTraceiD",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "first-container",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "moment-thumbnail",
    src: thumbnail
  }), /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "overlay"
  }), /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "titles",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    type: _.Label.Type.Heading1,
    className: "emoji"
  }, "\uD83D\uDC4D"), /*#__PURE__*/_react.default.createElement(_.Label, {
    color: _.Color.White2,
    type: _.Label.Type.Heading3,
    className: "title"
  }, title)), /*#__PURE__*/_react.default.createElement(_.RoundButton, {
    trkAction: "Close Pressed",
    className: "close-button",
    icon: _.Icon.Type.Close,
    backgroundColor: _.Color.Transparent,
    iconColor: _.Color.White2,
    iconSize: 24,
    onClick: onClose,
    width: 40,
    height: 40
  })), /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "second-container",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "14"
  }, /*#__PURE__*/_react.default.createElement(_.RoundButton, {
    trkAction: "Close Pressed",
    className: "close-button-landscape",
    icon: _.Icon.Type.Close,
    color: _.Color.Transparent,
    backgroundColor: _.Color.Transparent,
    iconColor: _.Color.Grey3,
    iconSize: 24,
    onClick: onClose,
    width: 40,
    height: 40
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: "down-arrow",
    src: _downArrow.default
  }), !loading && moment && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (firstName || lastName || userId) && /*#__PURE__*/_react.default.createElement(_.Avatar, {
    size: 40,
    marginBottom: 2,
    className: "user-avatar",
    imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(userId),
    initials: (0, _helpers.getInitials)(firstName, lastName)
  }), didCreateNewItem && /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    className: "subtitle"
  }, "This moment was saved to the", /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("a", {
    className: "playlist-link",
    href: playlistLink
  }, playlistTitle), " in your Trace iD"), !didCreateNewItem && /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    className: "subtitle"
  }, "This moment is already in the", /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("a", {
    className: "playlist-link",
    href: playlistLink
  }, playlistTitle), " in your Trace iD")), (loading || !moment) && /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "loading-container"
  }, /*#__PURE__*/_react.default.createElement(_.Loading, null))));
};

exports.AutoAddMomentToTraceiD = AutoAddMomentToTraceiD;
AutoAddMomentToTraceiD.defaultProps = {
  user: null,
  title: 'Success!',
  moment: null,
  playlistLink: null,
  playlistTitle: 'Favorites playlist',
  loading: false,
  error: null
};